import BulkOperationsController from './BulkOperationsController'

export default class BulkMoveCopyTasksController extends BulkOperationsController {
    constructor({
        method,
        onSuccess = () => {},
        onProgress = () => {},
        onFailure = () => {},
    }) {
        super({
            method,
            initialResult: {
                successTasksCount: 0,
                deletedTasksCount: 0,
                notAvailableTasksCount: 0,
                duplicateNameTasksCount: 0,
                invalidTaskStatusCount: 0,
            },
            combineFn: (result, chunkResult) => {
                return {
                    successTasksCount: result.successTasksCount + chunkResult.successTasksCount,
                    deletedTasksCount: result.deletedTasksCount + chunkResult.deletedTasksCount,
                    notAvailableTasksCount: result.notAvailableTasksCount + chunkResult.notAvailableTasksCount,
                    duplicateNameTasksCount: result.duplicateNameTasksCount + chunkResult.duplicateNameTasksCount,
                    invalidTaskStatusCount: result.invalidTaskStatusCount + chunkResult.invalidTaskStatusCount,
                }
            },
            onSuccess,
            onProgress,
            onFailure,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/controller/BulkMoveCopyTasksController.js